import { Divider, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { ITender } from 'types/tender'

const horizontalDivider = (
  <Divider
    sx={{
      borderStyle: 'dashed',
      borderWidth: '1.5px',
      flexGrow: 1,
      alignSelf: 'center',
    }}
    flexItem
  />
)

type Props = {
  tender: ITender
}

export const TenderGeneralInfo = ({ tender }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Stack spacing={1}>
        <Typography variant="h6">{t('general-info')}</Typography>
        <Divider flexItem />
        <Stack spacing={2}>
          <Stack direction="row">
            <Stack width="100%">
              <Typography variant="caption" fontWeight="bold">
                {t('organization-name')}
              </Typography>
              <Typography variant="body2">{tender.organizationName}</Typography>
            </Stack>
            <Stack width="100%">
              <Typography variant="caption" fontWeight="bold">
                {t('contestAuthor')}
              </Typography>
              <Typography variant="body2">{tender.createdByUsername}</Typography>
            </Stack>
          </Stack>
          <Stack direction="row">
            <Stack width="100%">
              <Typography variant="caption" fontWeight="bold">
                {t('contestName')}
              </Typography>
              <Typography variant="body2">{tender.name}</Typography>
            </Stack>
            <Stack width="100%">
              <Typography variant="caption" fontWeight="bold">
                {t('procurementMethod')}
              </Typography>
              <Typography variant="body2">{t(tender.method)}</Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Divider flexItem />
      <Stack spacing={1}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          divider={horizontalDivider}
        >
          <Typography variant="body2" fontWeight="bold">
            {t('tender-start-date-time')}
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {tender.startTime
              ? formatTimeStampToDate(tender.startTime)
              : t('notSpecified')}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          divider={horizontalDivider}
        >
          <Typography variant="body2" fontWeight="bold">
            {t('required-docs-date-time')}
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {tender.docSubmissionDeadline
              ? formatTimeStampToDate(tender.docSubmissionDeadline)
              : t('notSpecified')}
          </Typography>
        </Stack>
        {/*<Stack*/}
        {/*  direction="row"*/}
        {/*  alignItems="center"*/}
        {/*  justifyContent="space-between"*/}
        {/*  spacing={1}*/}
        {/*  divider={horizontalDivider}*/}
        {/*>*/}
        {/*  <Typography variant="body2" fontWeight="bold">*/}
        {/*    {t('endDateOfCompetition')}*/}
        {/*  </Typography>*/}
        {/*  <Typography variant="body2" fontWeight="bold">*/}
        {/*    {tender.envelopeOpeningTime*/}
        {/*      ? formatTimeStampToDate(tender.envelopeOpeningTime)*/}
        {/*      : t('notSpecified')}*/}
        {/*  </Typography>*/}
        {/*</Stack>*/}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          divider={horizontalDivider}
        >
          <Typography variant="body2" fontWeight="bold">
            {t('envelopeOpeningTime')}
          </Typography>
          <Typography variant="body2" fontWeight="bold">
            {tender.envelopeOpeningTime
              ? formatTimeStampToDate(tender.envelopeOpeningTime)
              : t('notSpecified')}
          </Typography>
        </Stack>
      </Stack>
    </>
  )
}
